/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import LinkWithArrow from 'app/developer-v3/components/LinkWithArrow';

import { VALIDATIONS_DOCS_URL } from '../Validate/constants';

type Props = {
  checkId: string;
};

const Styles = {
  root: css`
    padding: 15px;
  `,
};

const Footer = ({ checkId }: Props) => (
  <footer css={Styles.root}>
    <LinkWithArrow
      ariaLabel="Opens external link for documentation"
      href={`${VALIDATIONS_DOCS_URL}#${checkId}`}
      iconName="arrowOffsite"
      target="_blank"
    >
      Error code {checkId}
    </LinkWithArrow>
  </footer>
);

export default Footer;
